import {makeStyles} from "@material-ui/core";

export const useTagsBadgeStyles = makeStyles(() => ({
    root: {
        borderRadius: "16px",
        padding: "6px 12px 6px 12px",
        whiteSpace: "nowrap",
        display: "inline-block",
        marginRight: "8px !important"
    }
}));
